import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { Link } from "react-router-dom";

const styles = theme => ({
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
});

class TemporaryDrawerSubList extends React.Component {
  state = { open: false };

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  render() {
    const { classes, title, routes } = this.props;
    const { open } = this.state;
    const { handleClick } = this;


    return (
      <React.Fragment>
          <ListItem button onClick={handleClick}>
            <ListItemText primary={title} />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {routes.map((route) => 
                <ListItem key={route.name} className={classes.nested} component={Link} to={route.path}>
                  <ListItemText primary={route.name}/>
                </ListItem>)}
            </List>
          </Collapse>
          </React.Fragment>
    );
  }
}



export default withStyles(styles)(TemporaryDrawerSubList);


// WEBPACK FOOTER //
// ./src/components/Header/TemporaryDrawerSubList.js